export enum FactorRiskAssessmentLookupTypeEnum {
    Barrier = 1,
    Strength = 2,
}
